<template>
  <!-- The runtime workflow diagram is the same read-only diagram the GNey proposal card opens:
       one modal, one form card. This component only loads the module's diagram into it. -->
  <fts-flow-diagram-modal ref="ftsFlowDiagramModal" />
</template>

<script>
import flowDiagram from "../library/flowDiagram";
import { clientStore } from "../store/clientStore";

import FTSFlowDiagramModal from "./FTSFlowDiagramModal";

export default {
  components: {
    "fts-flow-diagram-modal": FTSFlowDiagramModal,
  },
  methods: {
    async show() {
      // open at once; the graph fills in when the diagram arrives
      this.$refs.ftsFlowDiagramModal.show(this.diagramData());
      let response = await clientStore.dispatch("loadDiagram", this.module.id);
      this.$refs.ftsFlowDiagramModal.update(this.diagramData(response.data));
    },
    diagramData(data) {
      return flowDiagram.fromDiagramPayload(data, this.moduleId ? this.module : null);
    },
    close() {
      this.$refs.ftsFlowDiagramModal.hide();
    },
  },
  computed: {
    module() {
      return clientStore.state.module;
    },
    moduleId() {
      return clientStore.getters.moduleId;
    },
  },
};
</script>
